export default __webpack_public_path__ + "images/c9135bf08353d2bf58db7d1efbce7e0c.png";